module.exports = __webpack_public_path__ + "static/media/logo-ps4-symbol.9f620300.svg";